import React, { Component } from 'react';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon, TimePicker, Col } from 'antd';
import { withState } from 'recompose';
import moment from 'moment';
import { keys, values } from 'lodash';
const FormItem = Form.Item;

class RoutesSettingsForm extends Component {
  
  state = {
    modalVisible: false,
    checkForInitialValues: false,
    id: 0,
  }
  
  form = null;

  remove = k => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');

    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  };

  add = (initialValue = null) => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    
    if (keys.length < 10) {
  
      // can use data-binding to get
      const nextKeys = keys.concat(this.state.id++);
      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys,
      });
  
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible,
      checkForInitialValues: nextProps.checkForInitialValues,
    });

    if (!this.state.checkForInitialValues && nextProps.initialValues && nextProps.initialValues.waypoints && nextProps.initialValues.waypoints.length > 0 && this.state.id < 1) {
      for (let i = 0; i < nextProps.initialValues.waypoints.length; i++) {
        this.add();
      }

      this.setState({ checkForInitialValues: true });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {        
        if (values.keys) delete values.keys;

        this.setState({ checkForInitialValues: false, id: 0});
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator, getFieldValue } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 18, offset: 6 },
      },
    };

    getFieldDecorator('keys', { initialValue: [] });
    const keys = getFieldValue('keys');
    this.formItems = keys.map((k, index) => (
      <Form.Item
        {...(index === 0 ? formItemLayout : formItemLayout)}
        label={index + 1}
        required={false}
        key={k}
      >
        {getFieldDecorator(`waypoints[${k}]`, {
          validateTrigger: ['onChange', 'onBlur'],
          initialValue: this.props.initialValues && this.props.initialValues.waypoints && this.props.initialValues.waypoints.length > 0
            ? this.props.initialValues.waypoints[k]
            : null,
          rules: [
            {
              required: true,
              whitespace: true,
              message: "Please input waypoint coordinates or delete this field.",
            },
            {
              validator: (rule, value, callback) => {
                if (value) {
                  // Regular expression for validating latitude and longitude in format: lat,lng (lat and lng can be positive or negative), example: 50.123456,14.123456
                  const regexExp = /^((\-?|\+?)?\d+(\.\d+)?),*((\-?|\+?)?\d+(\.\d+)?)$/gi;

                  if (regexExp.test(value)) {
                    callback();
                  } else {
                    callback('Wrong format of coordinates. Use format: "lat,lng"');
                  }
                } else {
                  callback();
                }
              }
            }
          ],
        })(<Input style={{ width: '60%', marginRight: 8 }} />)}
        {
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(k)}
          />
        }
      </Form.Item>
    ));

    this.formItems = ['Body průjezdu', ...this.formItems]

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Cesta" >
          {getFieldDecorator('routeName', {
            initialValue: this.props.initialValues && this.props.initialValues.routeName
              ? this.props.initialValues.routeName
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Popis" >
          {getFieldDecorator('description', {
            initialValue: this.props.initialValues && this.props.initialValues.description !== null
              ? this.props.initialValues.description
              : '',
          })(
            <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Začátek" >
          {getFieldDecorator('origin', {
            initialValue: this.props.initialValues && this.props.initialValues.origin
              ? this.props.initialValues.origin
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            },
            {
              validator: (rule, value, callback) => {
                if (value) {
                  // Regular expression for validating latitude and longitude in format: lat,lng (lat and lng can be positive or negative), example: 50.123456,14.123456
                  const regexExp = /^((\-?|\+?)?\d+(\.\d+)?),*((\-?|\+?)?\d+(\.\d+)?)$/gi;

                  if (regexExp.test(value)) {
                    callback();
                  } else {
                    callback('Wrong format of coordinates. Use format: "lat,lng"');
                  }
                } else {
                  callback();
                }
              }
            }
          ],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Konec" >
          {getFieldDecorator('destination', {
            initialValue: this.props.initialValues && this.props.initialValues.destination
              ? this.props.initialValues.destination
              : null,
              rules: [{
                required: true, message: 'Vyplňte prosím tuto položku!',
              },
              {
                validator: (rule, value, callback) => {
                  if (value) {
                    // Regular expression for validating latitude and longitude in format: lat,lng (lat and lng can be positive or negative), example: 50.123456,14.123456
                    const regexExp = /^((\-?|\+?)?\d+(\.\d+)?),*((\-?|\+?)?\d+(\.\d+)?)$/gi;
  
                    if (regexExp.test(value)) {
                      callback();
                    } else {
                      callback('Wrong format of coordinates. Use format: "lat,lng"');
                    }
                  } else {
                    callback();
                  }
                }
              }
            ],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Denní interval (min)" >
          {getFieldDecorator('checkIntervalDay', {
            initialValue: this.props.initialValues && this.props.initialValues.checkIntervalDay
              ? this.props.initialValues.checkIntervalDay
              : 30,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Noční interval (min)" >
          {getFieldDecorator('checkIntervalNight', {
            initialValue: this.props.initialValues && this.props.initialValues.checkIntervalNight
              ? this.props.initialValues.checkIntervalNight
              : 30,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <Divider />
        {this.formItems}
        <Form.Item 
        {...formItemLayoutWithOutLabel}
        >
          <Button type="dashed" onClick={this.add} style={{ width: '60%' }}>
            <Icon type="plus" /> Přidat bod průjezdu
          </Button>
        </Form.Item>
        <FormItem {...tailFormItemLayout}>
          {this.props.initialValues
            ?
            <Button type="primary" htmlType="submit">Uložit</Button>
            :
            <Button type="primary" htmlType="submit">Vložit</Button>
          }
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title={this.props.initialValues ? "Nastavení cesty pro výpočet doby dojezdu" : "Vložení nové cesty pro výpočet doby dojezdu"}
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false, checkForInitialValues: false, id: 0});
          }}
          okText={this.props.initialValues ? "Uložit" : "Vložit"}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedRoutesSettingForm = Form.create()(RoutesSettingsForm);

export default WrappedRoutesSettingForm;


// WEBPACK FOOTER //
// ./src/components/RoutesSettingsForm.js